class ConfiguratorQuality extends HTMLElement {
    constructor() {
      super();
  
      this.drawer = document.querySelector('configurator-drawer');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.backButton = this.querySelector('button.drawer__back');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.footer = this.querySelector('.drawer__footer');
      this.nextSteps = {};
      this.previousSteps = {};

      this.renderOptionPrices();
      this.getNextSteps();
      this.getPreviousSteps();
      this.renderFooter();
    }

    renderOptionPrices() {
      const lenseVariants = this.drawer.lenseVariants;

      const focusIdentifier = this.drawer.bundle.focus;
      const thicknessIdentifier = this.drawer.bundle.thickness;

      const focus = this.drawer.optionConfig.focus.find(({identifier}) => identifier == focusIdentifier);
      const thickness = this.drawer.optionConfig.thickness.find(({identifier}) => identifier == thicknessIdentifier);

      const qualityOptionElements = this.form.querySelectorAll('.drawer__form_option');

      for (const qualityOptionElement of qualityOptionElements) {
        const priceElementParent = qualityOptionElement.querySelector('.option_price');
        const priceElement = priceElementParent.querySelector('b');
        const qualityOptionTitle = qualityOptionElement.querySelector('.option_header b').textContent;

        const glassConfigurationTitle = `${focus.title} / ${thickness.title} / ${qualityOptionTitle}`;

        const correspondingVariant = lenseVariants.find(({public_title}) => public_title == glassConfigurationTitle);

        // if variant exists and therefore such configuration is possible
        if (correspondingVariant) {
          const correspondingVariantPrice = String(correspondingVariant.price / 100).replace('.', ',');
          
          priceElement.innerText = `+ ${correspondingVariantPrice} €`;
        } else if (qualityOptionTitle != 'Rodenstock Biometric Intelligent Glasses') {
          const noticeElement = document.createElement('span');
          
          noticeElement.classList.add('notice');
          noticeElement.classList.add('caption_text__thin');
          noticeElement.classList.add('disabled_notice');
          noticeElement.style = 'white-space: unset; color: initial;';
          noticeElement.innerText = 'Nicht kompatibel mit vorheriger Auswahl';

          priceElementParent.replaceWith(noticeElement);

          qualityOptionElement.querySelector('input').remove();
          qualityOptionElement.setAttribute('disabled', '');
        }
      }
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
  
      const lenseVariants = this.drawer.lenseVariants;

      const formData = new FormData(this.form);
      const qualityIdentifier = formData.get('quality');

      const focusIdentifier = this.drawer.bundle.focus;
      const thicknessIdentifier = this.drawer.bundle.thickness;

      const focus = this.drawer.optionConfig.focus.find(({identifier}) => identifier == focusIdentifier);
      const thickness = this.drawer.optionConfig.thickness.find(({identifier}) => identifier == thicknessIdentifier);
      const quality = this.drawer.optionConfig.quality.find(({identifier}) => identifier == qualityIdentifier);

      const glassConfigurationTitle = `${focus.title} / ${thickness.title} / ${quality.title}`;
      const correspondingVariant = lenseVariants.find(({public_title}) => public_title == glassConfigurationTitle);
  
      this.drawer.updateBundle('quality', qualityIdentifier);
      this.drawer.updateBundle('glassVariant', correspondingVariant);

      if (this.drawer.bundle?.focus == "none") {
        this.drawer.renderContents(this.nextSteps["extras"]);
      } else {
        this.drawer.renderContents(this.nextSteps["acuity"]);
      }
    }
  
    getNextSteps() {
      fetch('?sections=configurator-acuity,configurator-extras')
        .then((response) => response.json())
        .then((response) => {
          this.nextSteps['acuity'] = response['configurator-acuity'];
          this.nextSteps['extras'] = response['configurator-extras'];
          this.submitButton.removeAttribute('disabled');
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    getPreviousSteps() {
      fetch('?sections=configurator-thickness')
        .then((response) => response.json())
        .then((response) => {
          this.previousSteps['thickness'] = response['configurator-thickness'];
          this.backButton.removeAttribute('disabled');
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    renderPreviousStep() {
      this.drawer.renderContents(this.previousSteps['thickness']);
    }

    renderFooter() {
      const focusIdentifier = this.drawer.bundle.focus;
      const thicknessIdentifier = this.drawer.bundle.thickness;

      const focus = this.drawer.optionConfig.focus.find(({identifier}) => identifier == focusIdentifier);
      const thickness = this.drawer.optionConfig.thickness.find(({identifier}) => identifier == thicknessIdentifier);

      this.footer.querySelector('#chosenFocus').innerText = focus.title;
      this.footer.querySelector('#chosenThickness').innerText = thickness.title;

      this.footer.querySelector('#chosenFocus').removeAttribute('style');
      this.footer.querySelector('#chosenThickness').removeAttribute('style');
    }
  }
  
  customElements.define('configurator-quality', ConfiguratorQuality);
  